export default __webpack_public_path__ + "static/media/967.36daf588.png";